/** @jsxImportSource @emotion/react */
import React, { useState } from "react";


import Link from "@material-ui/core/Link";
import Typography from "@material-ui/core/Typography";
import PrintfileIcon from "@material-ui/icons/LocalPrintshop";

import axios from "axios";

import ToolbarButton from "./../../ToolbarButton";

import { useStoreon } from "storeon/react";
import t from "translations";


const PrintfileDebugger = props => {
  const [isPriftfileLoading, setIsPriftfileLoading] = useState(false);
  const [printfile, setPrintfile] = useState("");
  const { dispatch, cachePool, canvas } = useStoreon("cachePool", "canvas");
  const imagesCachingOnServer = cachePool.length ? true : false;

  const isLoading = imagesCachingOnServer;
  return (
    <React.Fragment>
      <ToolbarButton
        dark
        loading={isPriftfileLoading || isLoading}
        onClick={() => {
          if (isLoading) return;
          setPrintfile("");
          setIsPriftfileLoading(true);
          const canvasData = canvas.DPE.persistent.toBase64();
          axios
            .post("/wp-json/dpe/v1/render/printfile/debug", { canvasData })
            .then(resp => {
              console.info("Printfile ", resp.data);
              if (resp.data.printfile) {
                setPrintfile(resp.data.printfile);
                dispatch(
                  "notification/info",
                  `${t.renderedIn} ${resp.data.time.toFixed(3)}s`
                );
              }
            })
            .catch(err => {
              console.error("Printfile failed", err);
            })
            .finally(_ => {
              setIsPriftfileLoading(false);
            });
        }}
        vertical
        desc="Printfile"
        icon={<PrintfileIcon />}
      />
      <Typography component="p">
        {printfile && (
          <Link href={printfile} target="_blank" color="secondary">
            Printfile
          </Link>
        )}
      </Typography>
    </React.Fragment>
  );
};

export default PrintfileDebugger;
